<template>
    <div style="display: inline-block">
        <button @click="goPage(-1)"><i class="fa fa-arrow-left"></i></button>
        <input class="inpSm" min="1" type="number" v-model="page">
        <button @click="goPage(1)"><i class="fa fa-arrow-right"></i></button>
        {{ getTranslation('lbl_items_per_page') }}
        <input class="inpSm" type="number" min="1" v-model="perpage">
    </div>
</template>

<script>
   /**
    * tag:
    * <banet-pagination :count="count" @pagingEvent="setPage"></banet-pagination>
    * expect count - number of records
    * emit pagingEvent with an object {page:<navigated page>, perpage:<how many records to display per one page>}
    * parent method:
        setPage(pageData){
            // set paging on parent
            this.page = pageData.page;
            this.perpage = pageData.perpage;
            // get records per updated paging
            this.getRecords();
        }
    */

   import { translationMixin } from '../mixins/translationMixin';

    export default {
       mixins: [ translationMixin ],
       props: ['count'],
       data: function () {
          return {
             page: 1,
             perpage: 10,
             maxPages: 1,
             paginationUpdated: false
          }
       },
       methods: {
          goPage(val){
             let nextPage = this.page + val;
             this.page = (nextPage < 1) ? 1 : (nextPage > this.maxPages) ? this.maxPages : nextPage;
          },
          checkInt: function(){
             if (isNaN(this.page)) {
                this.page = 1;
             }
             if (isNaN(this.count)) {
                this.count = 0;
             }
             if (isNaN(this.perpage)) {
                this.perpage = 10;
             }
             this.page = (this.page <= 1) ? 1 : Math.ceil(this.page);
             this.perpage = (this.perpage <= 1) ? 1 : Math.ceil(this.perpage);
             this.count = (this.count <= 0) ? 0 : parseInt(this.count);
             this.maxPages = (this.count <= 1) ? 1 : Math.ceil(this.count / this.perpage);
          }
       },
       watch: {
          count: function () {
             this.checkInt();
          },
          page: function () {
             this.checkInt();
             this.maxPages = Math.ceil(this.count / this.perpage);
             this.page = (this.page <= 1) ? 1 : (this.page > this.maxPages) ? this.maxPages : this.page;
             this.paginationUpdated = true;
             this.$emit('pagingEvent', {page: this.page, perpage: this.perpage});
          },
          perpage: function () {
             this.checkInt();
             this.maxPages = Math.ceil(this.count / this.perpage);
             this.page = (this.page < 1) ? 1 : (this.page > this.maxPages) ? this.maxPages : this.page;
             this.paginationUpdated = true;
             this.$emit('pagingEvent', {page: this.page, perpage: this.perpage});
          }
       }
    }
</script>


// WEBPACK FOOTER //
// BanetPagination.vue?0b680c16